/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextInput from '@ba-ui-toolkit/textinput';
import stringResource from '../nls/StringResource';

function getString(value) {
	return stringResource.get(value);
}

export default class InputView extends Component {
	static propTypes = {
		...TextInput.propTypes,
		onSaveNewFile: PropTypes.func,
		dismissCreateFile: PropTypes.func,
		fileType: PropTypes.string,
		getLocaleString: PropTypes.func,
		placeholder: PropTypes.string,
	};

	static defaultProps = {
		dismissCreateFile: () => {},
		getLocaleString: getString,
	};
	state = {
		value: '',
	};

	componentDidMount() {
		setTimeout(() => {
			this._node._input.inputNode.focus();
		});
	}

	render() {
		const { getLocaleString, placeholder } = this.props;

		return (
			<TextInput
				ref={this._ref}
				onKeyDown={this._onKeyDown}
				onBlur={this._onBlur}
				placeholder={placeholder || getLocaleString('placeholder')}
				// autoFocus
				value={this.state.value}
				fullWidth
				onChange={v =>
					this.setState({
						value: v,
					})
				}
			/>
		);
	}

	_ref = node => {
		this._node = node;
	};

	_onBlur = () => {
		this.props.onSaveNewFile(this._node.props.value, this.props.fileType);
	};
	_saveFIle = () => {
		this.props.onSaveNewFile(this._node.props.value, this.props.fileType);
	};
	_onKeyDown = event => {
		// enter
		switch (event.keyCode) {
			// enter
			case 13: {
				this._saveFIle();
				break;
			}
			// esc
			case 27: {
				this.props.dismissCreateFile();
				break;
			}
			default:
		}
	};
}
